import {AppAdmissionListener, Keypad, KeypadListener} from "@variocube/app-api";

export class MockKeypad implements Keypad {

    private keypadListeners = new Set<KeypadListener>();
    private admissionListeners = new Set<AppAdmissionListener>();

    addKeypadListener(listener: KeypadListener): void {
        this.keypadListeners.add(listener);
    }

    removeKeypadListener(listener: KeypadListener): void {
        this.keypadListeners.delete(listener);
    }

    addAppAdmissionListener(listener: AppAdmissionListener) {
        this.admissionListeners.add(listener);
    }

    removeAppAdmissionListener(listener: AppAdmissionListener) {
        this.admissionListeners.delete(listener);
    }

    /**
     * Mocks entering an access code
     * @param code The access code.
     */
    enterAccessCode(code: string) {
        this.keypadListeners.forEach(listener => listener({code}))
    }
}